import {
    Document,
    Packer,
    Paragraph,
    TextRun,
    HeadingLevel,
    BorderStyle,
  } from "docx";
  import { saveAs } from "file-saver";

  const defaultTextColor = '4F5962'
  const sectionBreakColor = '91989E'
  const paragraphSize = 24
  const titleSize = 40
  const subtitleSize = 32
  const defaultFont = 'Arial'

  
  const createTitle = (text) =>
    new Paragraph({
      heading: HeadingLevel.HEADING_1,
      spacing: { after: 300 },
      children: [
        new TextRun({
          text,
          color: defaultTextColor,
          bold: true, 
        size: titleSize,
        font: defaultFont,
        }),
      ],
    });
  
  const createSubtitle = (text) =>
    new Paragraph({
      color: defaultTextColor,
      heading: HeadingLevel.HEADING_2,
      spacing: { before: 200, after: 300 },
      children: [
        new TextRun({
          text,
          color: defaultTextColor,
          bold: true, 
        size: subtitleSize,
        font: defaultFont,
        }),
      ],
    });
  
  const createSection = (title, content) => {
    const paragraphs = [];
  
    if (title) {
      paragraphs.push(
        new Paragraph({
          children: [new TextRun({ text: title, bold: true, color: defaultTextColor, size: paragraphSize, font: defaultFont, })],
          spacing: { before:100 ,after: 50 },
        })
      );
    }
  
    if (Array.isArray(content)) {
      content.forEach((item) => {
        paragraphs.push(
          new Paragraph({
            bullet: { level: 0 },
            children: [
                new TextRun({
                  text: item,
                  color: defaultTextColor,
                  size: paragraphSize,
                  font: defaultFont,
                }),
              ],
            spacing: { after: 30 },
          })
        );
      });
    } else if (content) {
      paragraphs.push(
        new Paragraph({
            children: [
                new TextRun({
                  text: content,
                  color: defaultTextColor,
                    size: paragraphSize,
                    font: defaultFont,
                }),
              ],
          spacing: { after: 100 },
        })
      );
    }
  
    return paragraphs;
  };

  const sectionBreak = () =>
    new Paragraph({
        children: [new TextRun(" ")], // Single space character
        border: {
          bottom: {
            style: BorderStyle.SINGLE,
            size: 6, // 1/2 pt
            color: sectionBreakColor,
          },
        },
        spacing: {
          before: 300,
          after: 300,
        },
      });

      const spacer = () =>
        new Paragraph({
            children: [new TextRun(" ")], // Single space character
            spacing: {
              before: 200,
              after: 200,
            },
          });

  
  
  
  const exportRFPasDocx = (documentData) => {
    const doc = new Document({
        sections: [],
      });
      

    if (!documentData) {
        console.error("No document data provided.");
        return;
      }
      
  
    const children = [];
  
    // Project Header Section
    children.push(createTitle(documentData["Project-Name"] || "Untitled Project"));
    children.push(...createSection("Issued By:", documentData["Issued-By"]));
    children.push(...createSection("Proposal Submission Deadline:", documentData["Proposal-Submission-Deadline"]));
    children.push(...createSection("Estimated Budget:", documentData["Estimated-Budget"]));
    children.push(sectionBreak());
    children.push(createSubtitle("Company Overview"));
    children.push(...createSection("Company Name:", documentData["Company-Name"]));
    children.push(spacer())
    children.push(...createSection("Mission Statement:", documentData["Mission-Statement"]));
    children.push(spacer())
    children.push(...createSection("Brand Guidelines:", documentData["Brand-Guidelines"]));
    children.push(sectionBreak());
    children.push(createSubtitle("Project Overview"));
    children.push(...createSection("Objective:", documentData["Project-Objective"]));
    children.push(spacer())
    children.push(...createSection("Target Audience:", documentData["Target-Audience"]));
    children.push(spacer())
    children.push(...createSection("Key Themes & Messaging:", documentData["Key-Themes-and-Messaging"]));
    children.push(spacer())
    children.push(...createSection("Featured Products & Services:", documentData["Featured-Products-and-Services"]));
    children.push(sectionBreak());
    children.push(createSubtitle("Video Details"));
    children.push(...createSection("Number of Videos:", documentData["Number-of-Videos"]));
    children.push(spacer())
    children.push(...createSection("Video Length:", documentData["Video-Length"]));
    children.push(spacer())
    children.push(...createSection("Video Style:", documentData["Video-Style"]));
    children.push(sectionBreak());
    children.push(createSubtitle("Project Timeline"));
    children.push(...createSection("Proposal Submission Deadline:", documentData["Proposal-Submission-Deadline"]));
    children.push(spacer())
    children.push(...createSection("Project Kickoff Date:", documentData["Project-Kickoff-Date"]));
    children.push(spacer())
    children.push(...createSection("Pre-Production:", documentData["Pre-Production-Timeline"]));
    children.push(spacer())
    children.push(...createSection("Shoot Dates:", documentData["Shoot-Dates"]));
    children.push(spacer())
    children.push(...createSection("Deliverables Due Date(s):", documentData["Deliverables-Due-Dates"]));
    children.push(sectionBreak());
    children.push(createSubtitle("Evaluation Criteria"));
    children.push(...createSection("Proposal Evaluation Criteria:", documentData["Proposal-Evaluation-Criteria"]));
    children.push(sectionBreak());
    children.push(createSubtitle("Budget & Legal Considerations"));
    children.push(...createSection("Estimated Budget:", documentData["Estimated-Budget"]));
    children.push(spacer())
    children.push(...createSection("Legal Requirements:", documentData["Legal-Requirements"]));
    children.push(sectionBreak());
    children.push(createSubtitle("Additional Notes"));
    children.push(...createSection("", documentData["Additional-Notes"]));
  
    doc.addSection({ children });
  
    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, `${documentData["Project-Name"] || "RFP"}.docx`);
    });
  };
  
  export default exportRFPasDocx;